// Gallery client — /api/cms/gallery

const API = '/api/cms/gallery';

export interface GalleryItem {
  id: string;
  category: 'repairs' | 'controllers' | 'strange';
  title: string;
  caption: string;
  subtitle: string;
  image_url: string;
  secondary_image_url: string;
  storage_path: string | null;
  secondary_storage_path: string | null;
  mime_type: string;
  sort_order: number;
  visible: boolean;
  featured: boolean;
  created_at: string;
  updated_at: string;
}

export async function fetchGalleryItems(): Promise<GalleryItem[]> {
  const res = await fetch(API);
  if (!res.ok) throw new Error('Failed to fetch gallery');
  const { items } = await res.json() as { items: GalleryItem[] };
  return items;
}

export async function adminFetchGalleryItems(token: string): Promise<GalleryItem[]> {
  const res = await fetch(API, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Failed to fetch gallery');
  const { items } = await res.json() as { items: GalleryItem[] };
  return items;
}

export async function adminCreateGalleryItem(token: string, data: Partial<GalleryItem>): Promise<GalleryItem> {
  const res = await fetch(API, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(await res.text());
  const { item } = await res.json() as { item: GalleryItem };
  return item;
}

export async function adminUpdateGalleryItem(token: string, id: string, data: Partial<GalleryItem>): Promise<GalleryItem> {
  const res = await fetch(`${API}/${id}`, {
    method: 'PUT',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(await res.text());
  const { item } = await res.json() as { item: GalleryItem };
  return item;
}

export async function adminDeleteGalleryItem(token: string, id: string): Promise<void> {
  const res = await fetch(`${API}/${id}`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(await res.text());
}

export async function adminReorderGalleryItems(token: string, orders: { id: string; sort_order: number }[]): Promise<void> {
  const res = await fetch(`${API}/reorder`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ orders }),
  });
  if (!res.ok) throw new Error(await res.text());
}

export async function adminGetGalleryUploadUrl(
  token: string,
  mimeType: string,
): Promise<{ signedUrl: string; path: string; publicUrl: string }> {
  const res = await fetch(`${API}/upload-url`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ mimeType }),
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
